import EnterpriseExperiments from 'bundles/epic/clients/__generated__/Enterprise';

const COACH_ENABLED_PATHS = ['/purchase/account', '/business/teams', '/business'];

/**
 * Determines if WES Ask Coursera should be displayed based on the current pathname.
 * Used across WES applications (teams-v2, ent-website, enterprise-admin-account).
 *
 * @param pathname - Current URL pathname from router
 * @returns boolean - true if coach should be shown
 */

export const shouldShowWESAskCoursera = (pathname: string): boolean => {
  const coachEnabled = EnterpriseExperiments.get('enableWESCoach');

  return Boolean(coachEnabled && COACH_ENABLED_PATHS.some((path) => pathname.includes(path)));
};
